<template functional>
  <div>
    <div class="page-heading cohorts-heading">
      <h1>Premier referrals by date</h1>
    </div>
    <p class="ut-w-full xl:ut-w-3/5 ut-text-neutral-300 intro">
      To increase the chances of winning more listings we recommend reconnecting with open referrals that have been delivered in the last 90 days.
    </p>
  </div>
</template>

<script>
export default {
  name: 'LeadCohortsHeader',
};
</script>

<style lang="scss" scoped>
.cohorts-heading {
  $padding: 1.25rem;
  padding-bottom: $padding;
  padding-top: $padding;
}
.intro {
  line-height: 1.5;
}
</style>
